import { render, staticRenderFns } from "./BoxesPerFulfillment.vue?vue&type=template&id=7b39ca42"
import script from "./BoxesPerFulfillment.vue?vue&type=script&lang=js"
export * from "./BoxesPerFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports